export default "__VITE_ASSET__ChiN2gpp__"